const config = {
  baseURL: process.env.REACT_APP_API_URL,
  accountId: process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID,
  playerId: process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID,
}

export { config }
